import "../styles/components/DifficultyLevels.css"

interface DifficultyLevelsProps {
    difficulty?: string
    difficultyValue?: number
    variant?: number
}

export function DifficultyLevels({
                                     difficulty = '',
                                     difficultyValue = 0,
                                     variant = 0
                                 }: DifficultyLevelsProps) {

    const renderDifficultyDots = (value: number) => {
        const dots = []
        const fullDots = Math.floor(value)
        const hasHalf = value % 1 !== 0

        for (let i = 0; i < 5; i++) {
            if (i < fullDots) {
                // Voller Punkt
                dots.push(
                    <span key={i} className="lvl">
                    <span></span>
                </span>
                )
            } else if (i === fullDots && hasHalf) {
                // Halber Punkt
                dots.push(
                    <span key={i} className="lvl">
                    <span className="half"></span>
                </span>
                )
            } else {
                // Leerer Punkt
                dots.push(
                    <span key={i} className="lvl"></span>
                )
            }
        }
        return dots
    }

    return (
        <div className={`difficulty-level variant-${variant}`}>
            <div className="difficulty-level-inner">
                <div className="dots">{renderDifficultyDots(difficultyValue)}</div>
                <div className="level-text">
                    <span className="text">{difficulty}</span>
                </div>
            </div>
        </div>
    )
}
